// Copyright 2021 Pangea Cyber Corporation
// Author: Pangea Cyber Corporation

import { Colors as OriginalColors } from "./colors";

export const Colors = { ...OriginalColors };

(Colors as any)["ErrorDark"] = "#97192F";
(Colors as any)["ErrorLight"] = "#F19683";
(Colors as any)["ErrorTint"] = "#FEF3F2";
(Colors as any)["ErrorMain"] = "#D33232";

(Colors as any)["WarningDark"] = "#A84B02";
(Colors as any)["WarningLight"] = "#F8C266";
(Colors as any)["WarningTint"] = "#FEF6EE";
(Colors as any)["WarningMain"] = "#EA7F04";

(Colors as any)["InfoContrast"] = "#FFFFFF";
(Colors as any)["InfoDark"] = "#2a8eaa";
(Colors as any)["InfoLight"] = "#63d5f6";
(Colors as any)["InfoMain"] = "#3CCBF4";

(Colors as any)["SuccessDark"] = "#217D0A";
(Colors as any)["SuccessLight"] = "#A5E76D";
(Colors as any)["SuccessTint"] = "#ECFDF3";
(Colors as any)["SuccessMain"] = "#3A8D11";
(Colors as any)["SuccessBackground"] = "#E8FBCE";

(Colors as any)["PrimaryContrast"] = "#FFFFFF";
(Colors as any)["PrimaryVeryDark"] = "#070628";
(Colors as any)["PrimaryDark"] = "#3D0F58";
(Colors as any)["PrimaryLight"] = "#c8c2d6";
(Colors as any)["PrimaryMain"] = "#551B76";
(Colors as any)["PrimaryContainerDark"] = "#240F38";
(Colors as any)["PrimaryContainerDarkAccent"] = "#190C26";

(Colors as any)["PrimaryAccentSkyBlue"] = (Colors as any)["InfoMain"];
(Colors as any)["PrimaryAccentGreen"] = "#17B26A";
(Colors as any)["PrimaryAccentBlue"] = "#2E90FA";
(Colors as any)["PrimaryAccentViolet"] = "#6938EF";
(Colors as any)["PrimaryAccentPeriwinkle"] = "#687AE9";
(Colors as any)["PrimaryAccentBackground"] = "#F9F9FB";
(Colors as any)["PrimaryAccentBackgroundLight"] = "#ECEEF6";
(Colors as any)["PrimaryAccentAi"] = "#826BFF";

(Colors as any)["SecondaryDark"] = "#CCD0D5";
(Colors as any)["SecondaryLight"] = "#F5F6F7";
(Colors as any)["SecondaryMain"] = "#E8EAED";

(Colors as any)["TextDisabled"] = "#A4AAAD";
(Colors as any)["TextPrimary"] = "#FFFFFF";
(Colors as any)["TextSecondary"] = "#B7B3C2";
(Colors as any)["TextContent"] = "#B7B3C2";
(Colors as any)["TextDark"] = "#FFFFFF";

(Colors as any)["HeadingText"] = "#FFFFFF";
(Colors as any)["BodyText"] = "#B7B3C2";

(Colors as any)["BackgroundBody"] = "#0A030F";
(Colors as any)["BackgroundBodyActive"] = "#13131A";
(Colors as any)["BackgroundFooter"] = "#260C3B";
(Colors as any)["BannerBackground"] = "#2B0E3B";

(Colors as any)["BorderDefault"] = "#DADCE0";
(Colors as any)["BorderDark"] = "#CDD2DB";

(Colors as any)["GreyA100"] = "#EAE6FF";
(Colors as any)["GreyA200"] = "#BFB6EE";
(Colors as any)["GreyA400"] = "#3D338F";
(Colors as any)["GreyA700"] = "#231E52";
(Colors as any)["GreyB900"] = "#263238";

(Colors as any)["GreyDisabled"] = "#E0E1E4";
(Colors as any)["IconDisabled"] = "#828AA4";

(Colors as any)["LightBlue"] = "#EAF7FD";
(Colors as any)["BlueGrey"] = "#ECEFF1";

(Colors as any)["heroShadow"] = "0px 0px 72px 0px rgb(23 46 103 / 50%)";
(Colors as any)["mainShadow"] = "0px 12px 42px 0px rgb(23 46 103 / 20%)";
(Colors as any)["featureShadow"] =
  "0px 0px 48px rgba(41, 173, 235, 0.08), 0px 38px 48px -20px rgba(50, 50, 93, 0.17)";
(Colors as any)["cardShadow"] = "0px 0px 48px rgba(41, 173, 235, 0.08)";

(Colors as any)["HeroText"] = "#F5F9FC";
(Colors as any)["HeroSubText"] = "#D7DEE3";

(Colors as any)["HomeBodyText"] = "#0C0A30";
(Colors as any)["HomeSubText"] = "#7F7F7F";
(Colors as any)["HomeHeroText"] = "#E8EBED";

(Colors as any)["ContainerOutline"] = "#DDDDDD";
(Colors as any)["ContentHighlight"] = "#F5F9FC";

(Colors as any)["CodeEditorBackground"] = "#0b1a2d";

(Colors as any)["PrimaryGradient"] =
  "linear-gradient(90deg, #551B76 0%, #3D0F58 100%)";

(Colors as any)["AiOutline"] = "#9D4CDE";

(Colors as any)["NavHighlight"] = "#B861FF";
